export const countries = [
  { value: 'AF', name: 'Afganistán' },
  { value: 'AL', name: 'Albania' },
  { value: 'DE', name: 'Alemania' },
  { value: 'AD', name: 'Andorra' },
  { value: 'AO', name: 'Angola' },
  { value: 'AI', name: 'Anguilla' },
  { value: 'AQ', name: 'Antártida' },
  { value: 'AG', name: 'Antigua y Barbuda' },
  { value: 'AN', name: 'Antillas Holandesas' },
  { value: 'SA', name: 'Arabia Saudí' },
  { value: 'DZ', name: 'Argelia' },
  { value: 'AR', name: 'Argentina' },
  { value: 'AM', name: 'Armenia' },
  { value: 'AW', name: 'Aruba' },
  { value: 'MK', name: 'ARY Macedonia' },
  { value: 'AU', name: 'Australia' },
  { value: 'AT', name: 'Austria' },
  { value: 'AZ', name: 'Azerbaiyán' },
  { value: 'BS', name: 'Bahamas' },
  { value: 'BH', name: 'Bahréin' },
  { value: 'BD', name: 'Bangladesh' },
  { value: 'BB', name: 'Barbados' },
  { value: 'BE', name: 'Bélgica' },
  { value: 'BZ', name: 'Belice' },
  { value: 'BJ', name: 'Benin' },
  { value: 'BM', name: 'Bermudas' },
  { value: 'BT', name: 'Bhután' },
  { value: 'BY', name: 'Bielorrusia' },
  { value: 'BO', name: 'Bolivia' },
  { value: 'BA', name: 'Bosnia y Herzegovina' },
  { value: 'BW', name: 'Botsuana' },
  { value: 'BR', name: 'Brasil' },
  { value: 'BN', name: 'Brunéi' },
  { value: 'BG', name: 'Bulgaria' },
  { value: 'BF', name: 'Burkina Faso' },
  { value: 'BI', name: 'Burundi' },
  { value: 'CV', name: 'Cabo Verde' },
  { value: 'KH', name: 'Camboya' },
  { value: 'CM', name: 'Camerún' },
  { value: 'CA', name: 'Canadá' },
  { value: 'TD', name: 'Chad' },
  { value: 'CL', name: 'Chile' },
  { value: 'CN', name: 'China' },
  { value: 'CY', name: 'Chipre' },
  { value: 'VA', name: 'Ciudad del Vaticano' },
  { value: 'CO', name: 'Colombia' },
  { value: 'KM', name: 'Comoras' },
  { value: 'CG', name: 'Congo' },
  { value: 'KP', name: 'Corea del Norte' },
  { value: 'KR', name: 'Corea del Sur' },
  { value: 'CI', name: 'Costa de Marfil' },
  { value: 'CR', name: 'Costa Rica' },
  { value: 'HR', name: 'Croacia' },
  { value: 'CU', name: 'Cuba' },
  { value: 'DK', name: 'Dinamarca' },
  { value: 'DM', name: 'Dominica' },
  { value: 'EC', name: 'Ecuador' },
  { value: 'EG', name: 'Egipto' },
  { value: 'SV', name: 'El Salvador' },
  { value: 'AE', name: 'Emiratos Árabes Unidos' },
  { value: 'ER', name: 'Eritrea' },
  { value: 'SK', name: 'Eslovaquia' },
  { value: 'SI', name: 'Eslovenia' },
  { value: 'ES', name: 'España' },
  { value: 'US', name: 'Estados Unidos' },
  { value: 'EE', name: 'Estonia' },
  { value: 'ET', name: 'Etiopía' },
  { value: 'PH', name: 'Filipinas' },
  { value: 'FI', name: 'Finlandia' },
  { value: 'FJ', name: 'Fiyi' },
  { value: 'FR', name: 'Francia' },
  { value: 'GA', name: 'Gabón' },
  { value: 'GM', name: 'Gambia' },
  { value: 'GE', name: 'Georgia' },
  { value: 'GH', name: 'Ghana' },
  { value: 'GI', name: 'Gibraltar' },
  { value: 'GD', name: 'Granada' },
  { value: 'GR', name: 'Grecia' },
  { value: 'GL', name: 'Groenlandia' },
  { value: 'GP', name: 'Guadalupe' },
  { value: 'GU', name: 'Guam' },
  { value: 'GT', name: 'Guatemala' },
  { value: 'GF', name: 'Guayana Francesa' },
  { value: 'GG', name: 'Guernesey' },
  { value: 'GN', name: 'Guinea' },
  { value: 'GQ', name: 'Guinea Ecuatorial' },
  { value: 'GW', name: 'Guinea-Bissau' },
  { value: 'GY', name: 'Guyana' },
  { value: 'HT', name: 'Haití' },
  { value: 'NL', name: 'Holanda o Países Bajos' },
  { value: 'HN', name: 'Honduras' },
  { value: 'HK', name: 'Hong Kong' },
  { value: 'HU', name: 'Hungría' },
  { value: 'IN', name: 'India' },
  { value: 'ID', name: 'Indonesia' },
  { value: 'IR', name: 'Irán' },
  { value: 'IQ', name: 'Iraq' },
  { value: 'IE', name: 'Irlanda' },
  { value: 'BV', name: 'Isla Bouvet' },
  { value: 'IM', name: 'Isla de Man' },
  { value: 'CX', name: 'Isla de Navidad' },
  { value: 'NF', name: 'Isla Norfolk' },
  { value: 'IS', name: 'Islandia' },
  { value: 'AX', name: 'Islas Aland' },
  { value: 'KY', name: 'Islas Caimán' },
  { value: 'CC', name: 'Islas Cocos' },
  { value: 'CK', name: 'Islas Cook' },
  { value: 'FO', name: 'Islas Feroe' },
  { value: 'GS', name: 'Islas Georgias del Sur y Sandwich del Sur' },
  { value: 'HM', name: 'Islas Heard y McDonald' },
  { value: 'FK', name: 'Islas Malvinas' },
  { value: 'MP', name: 'Islas Marianas del Norte' },
  { value: 'MH', name: 'Islas Marshall' },
  { value: 'PN', name: 'Islas Pitcairn' },
  { value: 'SB', name: 'Islas Salomón' },
  { value: 'TC', name: 'Islas Turcas y Caicos' },
  { value: 'UM', name: 'Islas ultramarinas de Estados Unidos' },
  { value: 'VG', name: 'Islas Vírgenes Británicas' },
  { value: 'VI', name: 'Islas Vírgenes de los Estados Unidos' },
  { value: 'IL', name: 'Israel' },
  { value: 'IT', name: 'Italia' },
  { value: 'JM', name: 'Jamaica' },
  { value: 'JP', name: 'Japón' },
  { value: 'JE', name: 'Jersey' },
  { value: 'JO', name: 'Jordania' },
  { value: 'KZ', name: 'Kazajstán' },
  { value: 'KE', name: 'Kenia' },
  { value: 'KG', name: 'Kirguistán' },
  { value: 'KI', name: 'Kiribati' },
  { value: 'KW', name: 'Kuwait' },
  { value: 'LA', name: 'Laos' },
  { value: 'LS', name: 'Lesotho' },
  { value: 'LV', name: 'Letonia' },
  { value: 'LB', name: 'Líbano' },
  { value: 'LR', name: 'Liberia' },
  { value: 'LY', name: 'Libia' },
  { value: 'LI', name: 'Liechtenstein' },
  { value: 'LT', name: 'Lituania' },
  { value: 'LU', name: 'Luxemburgo' },
  { value: 'MO', name: 'Macao' },
  { value: 'MG', name: 'Madagascar' },
  { value: 'MY', name: 'Malasia' },
  { value: 'MW', name: 'Malawi' },
  { value: 'MV', name: 'Maldivas' },
  { value: 'ML', name: 'Malí' },
  { value: 'MT', name: 'Malta' },
  { value: 'MA', name: 'Marruecos' },
  { value: 'MQ', name: 'Martinica' },
  { value: 'MU', name: 'Mauricio' },
  { value: 'MR', name: 'Mauritania' },
  { value: 'YT', name: 'Mayotte' },
  { value: 'MX', name: 'México' },
  { value: 'FM', name: 'Micronesia' },
  { value: 'MD', name: 'Moldavia' },
  { value: 'MC', name: 'Mónaco' },
  { value: 'MN', name: 'Mongolia' },
  { value: 'MS', name: 'Montserrat' },
  { value: 'MZ', name: 'Mozambique' },
  { value: 'MM', name: 'Myanmar' },
  { value: 'NA', name: 'Namibia' },
  { value: 'NR', name: 'Nauru' },
  { value: 'NP', name: 'Nepal' },
  { value: 'NI', name: 'Nicaragua' },
  { value: 'NE', name: 'Níger' },
  { value: 'NG', name: 'Nigeria' },
  { value: 'NU', name: 'Niue' },
  { value: 'NO', name: 'Noruega' },
  { value: 'NC', name: 'Nueva Caledonia' },
  { value: 'NZ', name: 'Nueva Zelanda' },
  { value: 'OM', name: 'Omán' },
  { value: 'PK', name: 'Pakistán' },
  { value: 'PW', name: 'Palau' },
  { value: 'PS', name: 'Palestina' },
  { value: 'PA', name: 'Panamá' },
  { value: 'PG', name: 'Papúa Nueva Guinea' },
  { value: 'PY', name: 'Paraguay' },
  { value: 'PE', name: 'Perú' },
  { value: 'PF', name: 'Polinesia Francesa' },
  { value: 'PL', name: 'Polonia' },
  { value: 'PT', name: 'Portugal' },
  { value: 'PR', name: 'Puerto Rico' },
  { value: 'QA', name: 'Qatar' },
  { value: 'GB', name: 'Reino Unido' },
  { value: 'CF', name: 'República Centroafricana' },
  { value: 'CZ', name: 'República Checa' },
  { value: 'CD', name: 'República Democrática del Congo' },
  { value: 'DO', name: 'República Dominicana' },
  { value: 'RE', name: 'Reunión' },
  { value: 'RW', name: 'Ruanda' },
  { value: 'RO', name: 'Rumania' },
  { value: 'RU', name: 'Rusia' },
  { value: 'EH', name: 'Sahara Occidental' },
  { value: 'WS', name: 'Samoa' },
  { value: 'AS', name: 'Samoa Americana' },
  { value: 'KN', name: 'San Cristóbal y Nevis' },
  { value: 'SM', name: 'San Marino' },
  { value: 'PM', name: 'San Pedro y Miquelón' },
  { value: 'VC', name: 'San Vicente y las Granadinas' },
  { value: 'SH', name: 'Santa Helena' },
  { value: 'LC', name: 'Santa Lucía' },
  { value: 'ST', name: 'Santo Tomé y Príncipe' },
  { value: 'SN', name: 'Senegal' },
  { value: 'CS', name: 'Serbia y Montenegro' },
  { value: 'SC', name: 'Seychelles' },
  { value: 'SL', name: 'Sierra Leona' },
  { value: 'SG', name: 'Singapur' },
  { value: 'SY', name: 'Siria' },
  { value: 'SO', name: 'Somalia' },
  { value: 'LK', name: 'Sri Lanka' },
  { value: 'SZ', name: 'Suazilandia' },
  { value: 'ZA', name: 'Sudáfrica' },
  { value: 'SD', name: 'Sudán' },
  { value: 'SE', name: 'Suecia' },
  { value: 'CH', name: 'Suiza' },
  { value: 'SR', name: 'Surinam' },
  { value: 'SJ', name: 'Svalbard y Jan Mayen' },
  { value: 'TH', name: 'Tailandia' },
  { value: 'TW', name: 'Taiwán' },
  { value: 'TZ', name: 'Tanzania' },
  { value: 'TJ', name: 'Tayikistán' },
  { value: 'IO', name: 'Territorio Británico del Océano Índico' },
  { value: 'TF', name: 'Territorios Australes Franceses' },
  { value: 'TL', name: 'Timor Oriental' },
  { value: 'TG', name: 'Togo' },
  { value: 'TK', name: 'Tokelau' },
  { value: 'TO', name: 'Tonga' },
  { value: 'TT', name: 'Trinidad y Tobago' },
  { value: 'TN', name: 'Túnez' },
  { value: 'TM', name: 'Turkmenistán' },
  { value: 'TR', name: 'Turquía' },
  { value: 'TV', name: 'Tuvalu' },
  { value: 'UA', name: 'Ucrania' },
  { value: 'UG', name: 'Uganda' },
  { value: 'UY', name: 'Uruguay' },
  { value: 'UZ', name: 'Uzbekistán' },
  { value: 'VU', name: 'Vanuatu' },
  { value: 'VE', name: 'Venezuela' },
  { value: 'VN', name: 'Vietnam' },
  { value: 'WF', name: 'Wallis y Futuna' },
  { value: 'YE', name: 'Yemen' },
  { value: 'DJ', name: 'Yibuti' },
  { value: 'ZM', name: 'Zambia' },
  { value: 'ZW', name: 'Zimbawe' },
];
